import "./styles.scss";

import moment from "moment-timezone";
import { FlagIcon } from "react-flag-kit";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

import {
  getSubType,
  updateTicket,
  getSubTypeID,
  postTicketCancel,
  postTicketClose,
  postTicketProceed,
  sendTicketMessage,
} from "../../store/middleware";
import TicketMessages from "./TicketMessages";
import Enter from "../../assets/images/btn_send.png";
import { timeDisplayFormat } from "../../utils/utils";
import Header from "../../components/Header/NewHeader";
import SideMenu from "../../components/SideMenu/SideMenu";
import { decryptIfEncrypted } from "../../utils/fieldDecryptor";
import IconAvatar from "../../assets/images/profile/img_placeholder.svg";
import closedImg from "../../assets/images/schedule/img_ticket-close.png";
import { setTicketCreated } from "../../store/slices/customerService.slice";
import InputTicketTypes from "../../components/elements/Inputs/InputTicketTypes";
import cancelImg from "../../assets/images/schedule/img_class-scheduled_cancel.png";
import { getFilterTickets } from "../../store/middleware/customerService.middleware";
import InputTicketSubTypes from "../../components/elements/Inputs/InputTicketSubTypes";
import CustomerService from "../../assets/images/icons/icon_customerservice_header.svg";

import { TicketStyle } from "./styles";

function Ticket() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.userReducer);
  const { ticket, ticketMessages } = useSelector((state) => state.customerServiceReducer);

  const [reason, setReason] = useState("");
  const [message, setMessage] = useState("");
  const [inputType, setInputType] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalAction, setModalAction] = useState("");
  const [inputSubType, setInputSubType] = useState([]);
  const [inputStatus] = useState(ticket && ticket?.status);

  const formatMomentJS = t("DATE_FORMAT").concat(` -  ${timeDisplayFormat(user?.timeDisplayFormat)}`);

  const loadInfos = () => {
    dispatch(getSubType());
    dispatch(getSubTypeID(ticket?.ticketTypeId));

    if (ticket) {
      setInputType(ticket?.ticketTypeId);
      setInputSubType(ticket?.ticketSubTypeId);
    }
  };

  useEffect(() => {
    loadInfos();
    // eslint-disable-next-line
  }, []);

  const statusChange = async (e) => {
    const { value } = e.target;
    value === "inProgress" && dispatch(postTicketProceed(ticket?.id)).then((res) => dispatch(setTicketCreated(res)));
    if (value !== "inProgress") {
      setModalOpen(true);
      setModalAction(value);
    }
    await dispatch(
      getFilterTickets({
        id: ticket?.id,
        requester: "",
        role: "",
        ticketTypeId: "",
        ticketSubTypeId: "",
        createdAt: "",
        status: "",
        pageNumber: 1,
        pageSize: 10,
      }),
    );
  };

  const inputChange = (e, name) => {
    const { value } = e.target;
    name === "type" && dispatch(getSubTypeID(value));
    switch (name) {
      case "type":
        setInputType(value);
        break;
      case "subType":
        setInputSubType(value);
        break;
      case "message":
        setMessage(value);
        break;
      case "reason":
        setReason(value);
        break;
      default:
        break;
    }
  };

  const confirmModal = async (ticketId) => {
    modalAction === "closed" && (await dispatch(postTicketClose(ticketId)));
    modalAction === "cancelled" &&
      (await dispatch(postTicketCancel(ticketId, { message: reason === "" ? "Cancel by User" : reason })));
    await dispatch(
      getFilterTickets({
        id: ticket?.id,
        requester: "",
        role: "",
        ticketTypeId: "",
        ticketSubTypeId: "",
        createdAt: "",
        status: "",
        pageNumber: 1,
        pageSize: 10,
      }),
    );
    setModalOpen(false);
    navigate("/customer-service");
  };

  const sendMessage = () => {
    dispatch(sendTicketMessage(ticket?.id, { message: message }));
    setMessage("");
  };

  const ticketUpdate = () => {
    dispatch(
      updateTicket(ticket?.id, {
        ticketTypeId: Number(inputType),
        ticketSubTypeId: Number(inputSubType),
        lingoLanguageId: Number(ticket.lingoLanguageId),
        title: ticket?.title,
        description: ticket?.description,
        active: Boolean(ticket?.active),
      }),
    );
    dispatch(
      getFilterTickets({
        id: ticket?.id,
        requester: "",
        role: "",
        ticketTypeId: "",
        ticketSubTypeId: "",
        createdAt: "",
        status: "",
        pageNumber: 1,
        pageSize: 10,
      }),
    );
  };

  return (
    <div className="view">
      <SideMenu lang={"english"} />
      {ticket && (
        <>
          <section>
            <Header
              title={`Ticket #${ticket?.id}`}
              icon={<img src={CustomerService} alt="Customer Service" />}
              typeIcon="custom"
              t={t}
            />
            <div className="contentTicket">
              <TicketStyle>
                <div>
                  <div className="topTicket">
                    <div className="numberTicket">
                      <span>
                        {t("OPEN_DATE")}: {moment(ticket?.createdAt).tz(user.timezone).format(formatMomentJS)}
                      </span>
                    </div>
                    <select
                      value={inputStatus}
                      onChange={(e) => statusChange(e)}
                      data-item={
                        ticket?.status === "open"
                          ? "OPEN"
                          : ticket?.status === "inProgress"
                          ? "IN_PROGRESS"
                          : "CANCELLED"
                      }
                    >
                      {ticket?.status === "open" && (
                        <option value="open">
                          {inputStatus === "open" && "•"} {t("OPEN")}
                        </option>
                      )}
                      {((ticket?.status === "open" &&
                        (user?.role === "companyManager" || user?.role === "customerService")) ||
                        ticket?.status === "inProgress") && (
                        <option value="inProgress">
                          {ticket?.status === "inProgress" && "•"} {t("IN_PROGRESS")}
                        </option>
                      )}
                      {ticket?.status !== "closed" &&
                        (ticket?.status === "cancelled" || user?.role === "student" || user?.role === "teacher") && (
                          <option value="cancelled">
                            {ticket?.status === "cancelled" && "•"} {t("CANCELLED")}
                          </option>
                        )}
                      {ticket?.status !== "cancelled" &&
                        (ticket?.status === "closed" ||
                          user?.role === "companyManager" ||
                          user?.role === "customerService") && (
                          <option value="closed">
                            {ticket?.status === "closed" && "•"} {t("CLOSED")}
                          </option>
                        )}
                    </select>
                  </div>

                  <div className="bigBox infoTicket">
                    <form>
                      <div className="infoTicket">
                        <label>{t("NAME")}: </label>
                        <p>{decryptIfEncrypted(ticket?.creatorUser.name)}</p>
                        <span className="tag">{t(`CARD_LIST_CUSTOM_SERVICE.${ticket?.creatorUser?.role}`)}</span>
                      </div>

                      <div className="infoTicket">
                        {(user?.role === "student" ||
                          user?.role === "teacher" ||
                          inputStatus === "closed" ||
                          inputStatus === "cancelled") && (
                          <Fragment>
                            <label>{t("TYPE")}: </label> {ticket?.ticketType.nameEnglish}{" "}
                            <label> {t("SUBTYPE")}:</label> {ticket?.ticketSubType.nameEnglish}
                          </Fragment>
                        )}{" "}
                        {(user?.role === "companyManager" || user?.role === "customerService") &&
                          !(inputStatus === "closed" || inputStatus === "cancelled") && (
                            <Fragment>
                              <InputTicketTypes
                                name="type"
                                value={inputType}
                                type={"ticketTypes"}
                                onChange={inputChange}
                              />
                              <InputTicketSubTypes
                                name="subType"
                                value={inputSubType}
                                type={"ticketSubTypes"}
                                onChange={inputChange}
                              />
                            </Fragment>
                          )}
                        <label>Lingo: </label> <FlagIcon code={ticket?.lingoLanguage.flag} />{" "}
                        <p>{decryptIfEncrypted(ticket?.lingoLanguage.language.name)}</p>
                      </div>
                      <hr />
                      <div className="infoTicket">
                        <label>{t("TITLE")}: </label> <p> {ticket?.title} </p>
                      </div>

                      <div className="infoTicket">
                        <label> {t("DESCRIPTION")}: </label> <p>{ticket?.description}</p>
                      </div>
                    </form>
                  </div>
                  {ticket?.status === "cancelled" && ticketMessages?.length > 0 && (
                    <Fragment>
                      <div className="topTicket">
                        <div className="numberTicketCancel">
                          <h3>{t("CARD_CLASS_CANCEL")}</h3>
                          <span>
                            {t("CANCEL_DATE")}: {moment(ticket?.updatedAt).format(formatMomentJS)}
                          </span>
                        </div>
                      </div>
                      <div className="bigBox">
                        <form>
                          <div className="infoTicket">
                            <p>{ticketMessages[ticketMessages?.length - 1].message}</p>
                          </div>
                        </form>
                      </div>
                    </Fragment>
                  )}

                  {ticketMessages?.length > 0 && <TicketMessages />}

                  {ticket?.status === "closed" && (
                    <div className="ticketClosed">
                      <h4>{t("CLOSED_TICKET")}</h4>
                      <span>{moment(ticket?.updatedAt).format(formatMomentJS)}</span>
                    </div>
                  )}

                  {ticket?.status === "cancelled" && (
                    <div className="notes">
                      <div className="ticketCancelled">
                        <h4>{t("CENCELLED_TICKET")}</h4>
                        <span>{moment(ticket?.updatedAt).format(formatMomentJS)}</span>
                      </div>
                    </div>
                  )}

                  {!(ticket?.status === "closed" || ticket?.status === "cancelled") && (
                    <div className="notes">
                      <div className="boxType send">
                        <div className="avatar">
                          <img src={user.picture || IconAvatar} alt="" />
                        </div>
                        <form>
                          <div className="typeMessage">
                            <textarea
                              value={message}
                              maxLength="2000"
                              className="input-lingo"
                              placeholder={t("TYPE_MESSAGE")}
                              onChange={(e) => inputChange(e, "message")}
                            ></textarea>
                          </div>
                          <button type="button" className="enter" onClick={() => sendMessage()}>
                            <img src={Enter} alt="" />
                          </button>
                        </form>
                      </div>
                    </div>
                  )}

                  <div className="buttons">
                    <button onClick={() => navigate(-1)} type="button">
                      {t("BTN_BACK")}
                    </button>
                    <Link to={"/customer-service"}>
                      <button type="button" className="button-save" onClick={(e) => ticketUpdate(e)}>
                        {t("BTN_SAVE")}
                      </button>
                    </Link>
                  </div>
                  <Dialog
                    keepMounted
                    open={modalOpen}
                    className="boxModal"
                    onClose={() => setModalOpen(false)}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                  >
                    <DialogTitle id="alert-dialog-slide-title" className="titleCancelClass">
                      {modalAction === "cancelled" && t("CANCEL_TICKET")}

                      {modalAction === "closed" && "Close ticket"}
                    </DialogTitle>
                    <DialogContent className="boxModal">
                      <DialogContentText id="alert-dialog-slide-description">
                        {modalAction === "closed" && (
                          <div>
                            <img src={closedImg} alt="closedImg" />
                            <h3>Do you really want to close this ticket ?</h3>
                          </div>
                        )}
                        {modalAction === "cancelled" && (
                          <div>
                            <img src={cancelImg} alt="cancelImg" />
                            <h3>{t("CANCEL_MESSAGE_TICKET")}</h3>
                          </div>
                        )}

                        {modalAction === "cancelled" && (
                          <textarea
                            value={reason}
                            onChange={(e) => inputChange(e, "reason")}
                            className="input-lingo inputManage"
                            placeholder={t("PLEASE_TELL_CANCEL_MESSAGE_TICKET")}
                            required
                          />
                        )}
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions className="boxModal">
                      <Button
                        onClick={() => confirmModal(ticket?.id)}
                        color="secondary"
                        autoFocus
                        style={{
                          width: "318px",
                          marginLeft: "10px",
                          background: "#FF5666",
                          color: "#fff",
                          border: "none",
                          fontFamily: "Work Sans, sans-serif",
                          fontWeight: "bold",
                          fontSize: "14px",
                          marginTop: "15px",
                        }}
                      >
                        {modalAction === "closed" && "Yes, close"}
                        {modalAction === "cancelled" && t("CANCEL_OPENDED_TICKET")}
                      </Button>
                      <Button
                        onClick={() => setModalOpen(false)}
                        color="primary"
                        autoFocus
                        style={{
                          backgroundColor: "transparent",
                          border: "1px solid #787780",
                          color: "#787780",
                          fontWeight: "500",
                        }}
                      >
                        {t("OOOPS_DONT")}
                      </Button>
                    </DialogActions>
                  </Dialog>
                </div>
              </TicketStyle>
            </div>
          </section>
        </>
      )}
    </div>
  );
}

export default Ticket;
